<template>
  <div
    ref="quillEditor"
    class="quill-editor app-quill-editor"
  >
    <div
      ref="quillToolBar"
      :id="toolBarId"
    >
      <select
        ref="select"
        class="ql-size"
        @change="onSelect"
      >
        <option
          v-for="size in fontSizes"
          :key="size.value"
          :value="size.value"
          :selected="selected === size.value"
        >{{ size.label }}</option>
      </select>
    </div>
    <div :id="quillEditorId"></div>
  </div>
</template>

<script>

import _Quill from 'quill'
import { onMounted, ref } from 'vue'
import { fontSizesPX } from '@/composables/textFormatter'

export default {
  name: 'AppQuillEditor',
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    value: {
      type: [Object, null],
      required: false
    },
    placeholder: {
      type: [String, Number, null],
      required: false
    }
  },
  emits: ['change-data'],
  setup(props, { emit }) {
    const key = props.id.toString().replace('_', '-')
    const quillEditorId = `quill-editor-${key}`
    const toolBarId = `toolbar-${key}`
    const fontSizes = fontSizesPX()
    const selected = ref(14)
    const select = ref(null)
    const quillEditor = ref(null)
    const quillToolBar = ref(null)
    const quill = ref(null)

    const initQuill = () => {
      quill.value = new _Quill(`#${quillEditorId}`, {
        theme: 'snow',
        placeholder: props.placeholder ? props.placeholder : 'Не указано',
        modules: {
          toolbar: {
            container: `#${toolBarId}`
          }
        }
      })
      quill.value.on('text-change', () => emitChange())
      loadQuillData()
      processQuillStyles()
    }
    const onSelect = e => {
      selected.value = e.target.value
      processQuillStyles()
      emitChange()
    }
    const processQuillStyles = () => {
      const select = quillToolBar.value.getElementsByClassName('ql-picker')[0]
      const span = select.getElementsByClassName('ql-picker-options')[0]
      const label = quillToolBar.value.getElementsByClassName('ql-picker-label')[0]
      const options = [...span.getElementsByClassName('ql-picker-item')]
      options.map(o => {
        if (o.getAttribute('data-value') === selected.value.toString()) {
          o.classList.add('selected')
        } else {
          o.classList.remove('selected')
        }
      })
      quillEditor.value.getElementsByClassName('ql-editor')[0].style.fontSize = `${selected.value}px`
      label.setAttribute('data-value', selected.value)
      label.setAttribute('data-label', `${selected.value} px`)
    }
    const loadQuillData = () => {
      if (props.value) {
        selected.value = props.value.fontSize ? parseInt(props.value.fontSize) : selected.value
        quill.value.setText(props.value.value)
      }
    }
    const emitChange = () => {
      let text = quill.value.getText()
      text = text && text[text.length - 1] === '\n' ? text.substring(0, text.length - 1) : text
      emit('change-data', {fontSize: selected.value, text})
    }

    onMounted(() => initQuill())

    return {
      quillEditorId,
      toolBarId,
      fontSizes,
      select,
      selected,
      quillEditor,
      quillToolBar,

      onSelect
    }
  }
}
</script>

<style lang='scss'>

@import '@/assets/scss/variables/variables';

.app-quill-editor {
  .ql-toolbar {
    .ql-picker {
      width: 70px;

      .ql-picker-label {
        border-radius: 0.357rem;
      }

      .ql-picker-options {
        margin-top: 4px;
        padding: 4px 0;
        border-radius: 0.357rem;

        .ql-picker-item {
          line-height: unset;
          height: 20px;
          padding: 0 8px;

          &::before {
            font-size: 13px;
          }

          &.ql-selected, &:hover, &.selected {
            background-color: $primary;
            color: $white;
            font-weight: bold;
            font-style: italic;
            //text-decoration: underline;
            //text-underline-offset: 5px;
          }
        }
      }
    }
  }

  .ql-editor {
    min-height: 200px;
  }
}

</style>
